var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationHandcard = function SvgSimpleIllustrationHandcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__handcard_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__handcard_svg__st1{fill:#e3a171}.simple-illustration__handcard_svg__st2{fill:none;stroke:#002140;stroke-width:.999;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__handcard_svg__st3{fill:#085239}")), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 41 32.3 24.8c-1.1-.8-2.7-.5-3.5.7l-8.4 12.3c-.8 1.1-.5 2.7.7 3.5l23.8 16.2c1.1.8 2.7.5 3.5-.7l8.4-12.3c.7-1.2.4-2.8-.7-3.5z",
    style: {
      fill: "#008c59"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3 27.6s.9.1 1.9.1c1-.1 2.4-.5 2.4-.5s.5 5.7 1.2 6.3c.7.7 3 2.4 5.2 1.2s3.1-1.4 2.7-2.9c-.4-1.5-3.5-7.3-3.5-7.3s-.1-3.2-.1-3.9.7-5.2-3.2-6c-3.9-.8-6.8-.7-9.3-1.6-2.4-.7-4.6-3-4.6-3s-9.6 3.9-9.8 12.1c0 0 3.7 3.5 5.1 6.1 1.4 2.5 3.2 8.7 5.5 8.8l6.5-9.4zM38.1 53 22.3 42.4s-4.6 3.9-2.6 6c2.1 2.1 5.5-.2 5.5-.2s-1.4 2.9 0 4.1c1.4 1.2 5.1-.4 5.1-.4s-1.5 3 .7 4.1c2.3 1.1 5.9-1.6 7.1-3z",
    className: "simple-illustration__handcard_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3 30.4 56 41c1.2.8 1.5 2.4.7 3.5l-8.3 12.3c-.8 1.2-2.4 1.5-3.5.7l-24-16.3c-1.2-.8-1.5-2.4-.7-3.5l7.1-10.4",
    className: "simple-illustration__handcard_svg__st2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.6 35.6-.3-.2c-.3-.2-.6-.1-.8.2l-.6.9c-.2.3-.1.6.2.8l.3.2c.3.2.6.1.8-.2l.6-.9c.2-.3.1-.6-.2-.8zM32.9 33.7l-.3-.2c-.3-.2-.6-.1-.8.2l-.4.6c-.2.3-.1.6.2.8l.3.2c.3.2.6.1.8-.2l.4-.6c.1-.2.1-.6-.2-.8zM33.1 37l-.3-.2c-.3-.2-.6-.1-.8.2l-.4.6c-.2.3-.1.6.2.8l.3.2c.3.2.6.1.8-.2l.4-.6c.1-.3 0-.6-.2-.8zM34.5 34.8l-.3-.2c-.3-.2-.6-.1-.8.2l-.6.9c-.2.3-.1.6.2.8l.3.2c.3.2.6.1.8-.2l.6-.9c.1-.2 0-.6-.2-.8z",
    className: "simple-illustration__handcard_svg__st3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m52.7 41.8-8.3-5.6c-1-.7-2.4-.4-3.1.6s-.4 2.4.6 3.1l8.3 5.6c1 .7 2.4.4 3.1-.6.7-1 .4-2.4-.6-3.1z",
    style: {
      fill: "#03d47c"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 10s-9.3 3.7-9.9 12c6 4.8 6.9 12.1 10.5 15.2M22.4 42.3c-2.8 2-4.3 5.5-1.8 6.7 1.8.9 4-.4 5.4-1.5",
    className: "simple-illustration__handcard_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 45.9c-3 2.5-4.4 5.5-1.9 6.7 1.6.8 3.5-.1 4.8-1.1",
    className: "simple-illustration__handcard_svg__st2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6 49.3c-3.1 2.8-4.2 5.6-1.8 6.8 1.8.9 4.2.2 7.2-3.2M23.7 39l4.9 3.4M30.9 43.9l4.9 3.4",
    className: "simple-illustration__handcard_svg__st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m29.2 36.2 2.7-4c.1-.2.1-.5-.1-.6l-1.4-.9c-.1-.1-.3-.1-.4-.1l-.9.3c-.1 0-.2.1-.2.2l-2 2.9c-.1.1-.1.2-.1.3v.7c0 .1.1.3.2.4l1.5 1c.2 0 .5 0 .7-.2z",
    className: "simple-illustration__handcard_svg__st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 26.2s3.9 2.9 6.6.6c-.6 5.4 2.1 10 6.9 7.7 4.8-2.3-1.1-7.9-1.5-10.8s1.2-5.4-1.4-7.9c-2.7-2.5-11.5-.7-15.8-5.8",
    className: "simple-illustration__handcard_svg__st2"
  })));
};
export default SvgSimpleIllustrationHandcard;